(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lm-card-product"] && !Shopify.designMode) return;
  try {
    // Toast-Benachrichtigung: „In den Warenkorb gelegt" + Produktbild + Warenkorb-Link.
  function lmToast(opts) {
    var host = document.getElementById('lm-toast-host');
    if (!host) { host = document.createElement('div'); host.id = 'lm-toast-host'; host.className = 'lm-toast-host'; document.body.appendChild(host); }
    var el = document.createElement('div');
    el.className = 'lm-toast';
    var img = opts.img ? '<img class="lm-toast__img" src="' + opts.img + '" alt="">' : '';
    var cartUrl = opts.cartUrl || '/cart';
    el.innerHTML =
      img +
      '<div class="lm-toast__body">' +
      '<span class="lm-toast__sub"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg> In den Warenkorb gelegt</span>' +
      '<span class="lm-toast__title">' + (opts.title || '') + '</span>' +
      '</div>' +
      '<a class="lm-toast__link" href="' + cartUrl + '">Warenkorb</a>';
    host.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); }, 300);
    }, 3400);
  }

  // „+" auf Produktkarten: per AJAX hinzufügen, Warenkorb NICHT öffnen (kein Redirect).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.lm-add-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.dataset.busy) return;
    if (btn) { btn.dataset.busy = '1'; btn.classList.add('is-loading'); }
    var routes = window.routes || {};
    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-lm-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.classList.remove('is-empty');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        lmToast({
          title: btn ? btn.dataset.lmTitle : '',
          img: btn ? btn.dataset.lmImg : '',
          cartUrl: routes.cart_url || '/cart',
        });
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); delete btn.dataset.busy; }, 1400); }
      })
      .catch(function () {
        if (btn) { btn.classList.remove('is-loading'); delete btn.dataset.busy; }
        lmToast({ title: 'Konnte nicht hinzugefügt werden' });
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lm-variety-count"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lmVarietyCountInit) return; // nur einmal pro Seite
    window.__lmVarietyCountInit = true;

    function fill() {
      var els = document.querySelectorAll('[data-lm-variety-count]');
      if (!els.length) return;
      fetch('/apps/candy/config', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !Array.isArray(d.varieties)) return;
          var n = Math.floor(d.varieties.length / 10) * 10;
          if (n < 10) return; // zu wenig für eine „über N"-Aussage → Fallback lassen
          els.forEach(function (el) { el.textContent = n; });
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fill);
    } else {
      fill();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
